import Vue from 'vue'
import Router from 'vue-router'
import TopupPhoneView from './views/TopupPhoneView'
import TopupEnergyView from './views/TopupEnergyView'
import TopupCodesView from './views/TopupCodesView'
import { ROUTING } from './const/routing.const'

Vue.use(Router)

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: ROUTING.topupPhone,
      name: 'topupPhone',
      component: TopupPhoneView
    },
    {
      path: ROUTING.topupEnergy,
      name: 'topupEnergy',
      component: TopupEnergyView
    },
    {
      path: ROUTING.topupCodes,
      name: 'topupCodes',
      component: TopupCodesView
    },
    {
      path: '*',
      redirect: ROUTING.topupPhone
    }
  ]
})
